export default __webpack_public_path__ + "static/media/Spectral-Italic.ea7383cf.ttf";